import {
  Config,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
  IFinalResponse,
} from '../Core';

import { CmsDeliveryTypes as Internals } from '../Types/internals';
export const API_DOMAIN: EndPointsNames = 'ApiCms';
export const ENDPOINT_API_PATH = 'api/v1.0/delivery/contents';

export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_AUTH_USER';
export const URL_POSTMAN = ``;

export const CODE_ERRORS: ErrorResponseCodeType<null>[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

const callGet = (
  params: Internals.CmsDeliveryRequest,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    pathUrl: `${ENDPOINT_API_PATH}/${params.contentId}`,
    params: { format: 'simple' },
  };
  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { get: callGet };

export default { call, definitions };
